<template>
  <ul class="tag-list">
    <TagListTag
      v-if="allButton"
      :active="allActive"
      :title="allText"
      :text="allText"
      :enable-toggling="enableToggling"
      :disabled="disabled"
      :small="small"
      :gray="gray"
      @click="toggleAll"
    />
    <TagListTag
      v-for="(tag, itemIndex) in tags"
      :key="itemIndex"
      :active="isActive(tag.id)"
      :icon="tag.icon"
      :title="tag.title"
      :text="tag.text"
      :enable-toggling="enableToggling"
      :disabled="disabled"
      :small="small"
      :gray="gray"
      @click="toggleItem(tag.id)"
    />
  </ul>
</template>

<script>
  import getTr from 'translation';
  import TagListTag from 'components/Inputs/Select/Tags/TagListTag';

  export default {
    name: 'TagList',
    components: {TagListTag},
    props: {
      tags: {
        type: Array,
        required: true
      },
      value: {
        type: Array,
        default: Array
      },
      allText: {
        type: String,
        default: () => getTr('all')
      },
      disabled: Boolean,
      gray: Boolean,
      small: Boolean,

      /*
       * allows you to deactivate active tag
       * mustn't be false  if allowMultipleSelect: true
       */
      enableToggling: {
        type: Boolean,
        default: true
      },

      // allows select more than one tag
      allowMultipleSelect: {
        type: Boolean,
        default: true
      },

      // allows to select all tags by clicking on all button tag
      allButton: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      allActive () {
        return this.activeTags.length === this.tags.length;
      },
      activeTags: {
        get () {
          return this.value;
        },
        set (val) {
          this.$emit('input', val);
        }
      }
    },
    watch: {
      value (value) {
        this.activeTags = value;
      }
    },
    methods: {
      toggleAll () {
        if (this.allActive) {
          this.activeTags = [];
        } else {
          this.activeTags = this.tags.map(item => item.id);
        }
      },
      isActive (tagId) {
        return this.value.includes(tagId);
      },
      toggleItem (itemId) {
        if (!this.allowMultipleSelect) {
          this.activeTags = [itemId];
        } else if (this.enableToggling || this.allowMultipleSelect) {
          if (this.isActive(itemId)) {
            this.activeTags.splice(this.value.indexOf(itemId), 1);
          } else {
            this.activeTags = [...this.value, itemId];
          }
        }
      }
    }
  };
</script>

<style>
  .tag-list {
    display: flex;

    flex-wrap: wrap;

    padding-left: 0;

    margin: 0;
  }
</style>
